import { Environments } from "@/config/env";
import { APP_VERSION } from "@/constants/version";

export const SENTRY_RELEASE = `Dualio@${APP_VERSION ?? "0.0.0"}`;

export const SENTRY_ENABLED_ENVIRONMENTS: Environments[] = [
  Environments.STAGE,
  Environments.PRODUCTION,
];

export const SENTRY_CONFIG = {
  TRACES_SAMPLE_RATE: {
    [Environments.STAGE]: 0.5,
    [Environments.PRODUCTION]: 0.1,
    [Environments.LOCAL]: 0,
    [Environments.DEVELOP]: 0,
    [Environments.TEST]: 0,
  },

  REPLAYS_SESSION_SAMPLE_RATE: {
    [Environments.STAGE]: 0.1,
    [Environments.PRODUCTION]: 0.01,
    [Environments.LOCAL]: 0,
    [Environments.DEVELOP]: 0,
    [Environments.TEST]: 0,
  },

  REPLAYS_ERROR_SAMPLE_RATE: {
    [Environments.STAGE]: 1.0,
    [Environments.PRODUCTION]: 1.0,
    [Environments.LOCAL]: 0,
    [Environments.DEVELOP]: 0,
    [Environments.TEST]: 0,
  },
} as const;

export const SENTRY_IGNORED_ERRORS = [
  "Failed to fetch",
  "NetworkError",
  "Load failed",
  "Network request failed",

  "ChunkLoadError",
  "Loading chunk",

  "AbortError",
  "The operation was aborted",

  "ResizeObserver loop",
];

export const SENTRY_IGNORED_STACK_PATTERNS = [
  /chrome-extension:\/\//,
  /moz-extension:\/\//,
  /safari-extension:\/\//,
  /gtm\.js/,
  /googletagmanager\.com/,
];

export const SENTRY_IGNORED_TRANSACTIONS = ["/api/health", "/_next/", "/favicon"];
